import { application } from "./applicationState.js";
import { wishlist } from "./wishlist.js";
import { cart } from "./cart.js";
import { user } from "./user.js";
import { cars } from "./cars.js";
import { csvPreview } from "./csvPreview.js";
import { quickBid } from "./quickBid.js";

import createPersistedState from "vuex-persistedstate";

export const dataState = createPersistedState({
  paths: [
    'user',
    'application',
    'cart',
    'wishlist',
    // cars module: persist data but NOT appLoading
    'cars.makers',
    'cars.cars',
    'cars.carListForShopPage',
    'cars.selectedCar'
  ]
})

export const modules = {
  app: application,
  wishlist,
  cart,
  user,
  cars,
  csvPreview,
  // Deliberately absent from dataState paths above: an in-flight bid should
  // not survive a browser restart, and persisting `car` would cache a stale MSRP.
  quickBid
};
